/* eslint-disable react/no-array-index-key */
/* eslint-disable object-shorthand */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import CN from 'classnames';
import { Button, Input, SimpleSelect } from 'components/atoms';
import { ComplexDateRangePicker } from 'components/atoms/ComplexDateRangePicker';
import {
  useGetDashboardDownloadView,
  useGetDashboardGenerateReportByDateRange,
  useGetDashboardStats,
  useGetDashboardStatsForEarnings,
  useGetDashboardTop10Videos,
  useGetDashboardTotalViews,
} from 'framework/api/methods';
import React, { FC, useEffect, useRef, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export interface DashboardProps {
  [x: string]: any;
}

export const Dashboard: FC<DashboardProps> = () => {
  const navigate = useNavigate();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [isOpenDatePicker, setIsOpenDatePicker] = useState(false);
  const [monthStats, setMonthStats] = useState<any>({});
  const [totalMinute, setTotalMinute] = useState(0);
  const [top10Videos, setTop10Videos] = useState([]);
  const [watchData, setWatchData] = useState([]);
  const [selectedType, setSelectedType] = useState({
    label: 'Total Views',
    value: 'totalViews',
  });
  const [selectedDate, setSelectedDate] = useState({
    startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    endDate: new Date(),
  });

  const onSuccessDashboardStats = (data: any) => {
    //
  };

  const onSuccessDashboardVideos = (data: any) => {
    setTop10Videos(data?.videos ?? []);
  };

  const onErrorDashboardStats = ({ response: { data: errData }, response }: any) => {
    if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
      notify('Session expired.', 'error');
      setTimeout(() => {
        navigate('/auth/login');
        localStorage.clear();
      }, 2000);
    } else {
      notify(errData?.message || 'Something went wrong.', 'error');
    }
  };

  const onErrorDashboardVideos = ({ response: { data: errData }, response }: any) => {
    if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
      notify('Session expired.', 'error');
      setTimeout(() => {
        navigate('/auth/login');
        localStorage.clear();
      }, 2000);
    } else {
      // notify(errData?.message || 'Something went wrong.', 'error');
    }
  };

  /** Get all cards API */
  const { refetch: getDashboardStats, data } = useGetDashboardStats(
    onSuccessDashboardStats,
    onErrorDashboardStats,
  );
  const { refetch: getDashboardTop10Videos } = useGetDashboardTop10Videos(
    onSuccessDashboardVideos,
    onErrorDashboardVideos,
  );

  const { mutate: getDashboardStatsForEarningsMutate } = useGetDashboardStatsForEarnings();

  const getPreviousMonth = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}/${month}`;
  };

  // function to request Otp for registered / unregistered users
  const getDashboardStatsForEarnings = () => {
    getDashboardStatsForEarningsMutate(
      {
        date: getPreviousMonth(),
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setMonthStats(successData?.data);
          // setTotalMinute(successData?.data?.total_minutes);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const { mutate: getDashboardActivityInMinsMutate } = useGetDashboardTotalViews();
  const { mutate: getDashboardExportReportMutate, isLoading: getDashboardExportReportIsLoading } =
    useGetDashboardDownloadView();

  const {
    mutate: getDashboardGenerateReportByDateRangeMutate,
    isLoading: getDashboardGenerateReportByDateRangeIsLoading,
  } = useGetDashboardGenerateReportByDateRange();

  const formatToYYYYMMDD = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // function to request Otp for registered / unregistered users
  const getDashboardActivityInMins = () => {
    getDashboardActivityInMinsMutate(
      {
        startDate: formatToYYYYMMDD(selectedDate.startDate),
        endDate: formatToYYYYMMDD(selectedDate.endDate),
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setWatchData(successData?.data);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // function to export report
  const getDashboardExportReport = () => {
    getDashboardExportReportMutate(
      {
        startDate: formatToYYYYMMDD(selectedDate.startDate),
        endDate: formatToYYYYMMDD(selectedDate.endDate),
      },
      {
        onSuccess: ({ data: successData }: any) => {
          const blob = new Blob([successData]);

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `total-views-report-${formatToYYYYMMDD(
            selectedDate.startDate,
          )}-${formatToYYYYMMDD(selectedDate.endDate)}.xlsx`; // Customize the file name
          document.body.appendChild(link);
          link.click();

          // Cleanup
          link.remove();
          window.URL.revokeObjectURL(url);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // function to export report
  const getDashboardGenerateReportByDateRange = () => {
    getDashboardGenerateReportByDateRangeMutate(
      {
        startDate: formatToYYYYMMDD(selectedDate.startDate),
        endDate: formatToYYYYMMDD(selectedDate.endDate),
        type: selectedType.value,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          const blob = new Blob([successData]);

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `report-for-${selectedType.value}-${formatToYYYYMMDD(
            selectedDate.startDate,
          )}-${formatToYYYYMMDD(selectedDate.endDate)}.xlsx`; // Customize the file name
          document.body.appendChild(link);
          link.click();

          // Cleanup
          link.remove();
          window.URL.revokeObjectURL(url);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else if (response?.status === 404) {
            notify('No data found.', 'error');
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  useEffect(() => {
    getDashboardStats();
    getDashboardStatsForEarnings();
    getDashboardTop10Videos();
  }, []);

  useEffect(() => {
    getDashboardActivityInMins();
  }, []);

  const chartData = {
    labels: watchData?.map((entry: any) => entry?.date),
    datasets: [
      {
        label: 'View count',
        data: watchData?.map((entry: any) => Number(entry?.view_count)),
        backgroundColor: '#C40D42',
        borderRadius: 6,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value: number | string) {
            if (typeof value === 'number') {
              return value >= 1000 ? `${value / 1000}k` : value;
            }
            return value;
          },
        },
      },
    },
  };

  const pickerRef: any = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
        getDashboardActivityInMins();
        setIsOpenDatePicker(false);
      }
    }

    if (isOpenDatePicker) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpenDatePicker, setIsOpenDatePicker]);

  const formatDate = (date: Date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = String(date.getFullYear()).slice(-2);
    return `${day} ${month} ${year}`;
  };

  const formatViews = (views: any) => {
    if (views >= 1_000_000) {
      return `${(views / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
    }
    if (views >= 1_000) {
      return `${(views / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
    }
    return views ?? 0;
  };

  return (
    <div className="flex gap-5 w-full h-full p-5 lg:flex-row flex-col lg:overflow-hidden overflow-y-auto">
      <div className="flex flex-col gap-5 lg:w-3/5 w-full h-auto">
        <div className="card-summary bg-white lg:h-auto h-auto px-4 py-3 rounded-[20px] flex flex-col justify-between shadow-sm">
          <div className="font-semibold text-lg text-[#05004E]">Summary</div>

          <div className="flex justify-between items-center gap-x-3 pt-2">
            <div className="w-1/4 max-w-1/4  h-[164px] bg-[#FFE2E5] rounded-2xl p-3">
              <div className="flex items-start justify-between w-full">
                <div className="h-10 w-10 rounded-full bg-[#FA5A7D] flex justify-center items-center">
                  <i className="ri-coupon-fill text-white text-[22px] leading-none" />
                </div>
                {/* <div className="border border-[#FA5A7D] rounded px-3 w-fit flex justify-center items-center hover:bg-[#f9cfd8]">
                  <i className="ri-arrow-right-long-line text-[#FA5A7D] text-[16px] leading-none cursor-pointer " />
                </div> */}
              </div>
              <div className="text-2xl text-[#151D48] font-semibold pt-4">
                {data?.data?.total_tickets || 0}
              </div>
              <div className="text-sm text-[#425166] font-medium break-words line-clamp-2">
                Total Tickets Count
              </div>
            </div>

            <div className="w-1/4 max-w-1/4  h-[164px] bg-[#FFF4DE] rounded-2xl p-3">
              <div className="flex items-start justify-between w-full">
                <div className="h-10 w-10 rounded-full bg-[#FF947A] flex justify-center items-center">
                  <i className="ri-folder-video-line text-white text-[22px] leading-none" />
                </div>
                {/* <div className="border border-[#FF947A] rounded px-3 w-fit flex justify-center items-center hover:bg-[#ffe2db]">
                  <i className="ri-arrow-right-long-line text-[#FF947A] text-[16px] leading-none cursor-pointer " />
                </div> */}
              </div>
              <div className="text-2xl text-[#151D48] font-semibold pt-4">
                {data?.data?.total_videos || 0}
              </div>
              <div className="text-sm text-[#425166] font-medium">Total Videos</div>
            </div>

            <div className="w-1/4 max-w-1/4 h-[164px] bg-[#DCFCE7] rounded-2xl p-3">
              <div className="flex items-start justify-between w-full">
                <div className="h-10 w-10 rounded-full bg-[#3CD856] flex justify-center items-center">
                  <i className="ri-file-list-2-line text-white text-[22px] leading-none" />
                </div>
                {/* <div className="border border-[#3CD856] rounded px-3 w-fit flex justify-center items-center hover:bg-[#d3f8d9]">
                  <i className="ri-arrow-right-long-line text-[#3CD856] text-[16px] leading-none cursor-pointer " />
                </div> */}
              </div>
              <div className="text-2xl text-[#151D48] font-semibold pt-4">
                {data?.data?.total_creators || 0}
              </div>
              <div className="text-sm text-[#425166] font-medium break-words line-clamp-2">
                Total Content Creators Count
              </div>
            </div>

            <div className="w-1/4 max-w-1/4  h-[164px] bg-[#F3E8FF] rounded-2xl p-3">
              <div className="flex items-start justify-between w-full">
                <div className="h-10 w-10 rounded-full bg-[#BF83FF] flex justify-center items-center">
                  <i className="ri-building-line text-white text-[22px] leading-none" />
                </div>
                {/* <div className="border border-[#BF83FF] rounded px-3 w-fit flex justify-center items-center hover:bg-[#eaddf8]">
                  <i className="ri-arrow-right-long-line text-[#BF83FF] text-[16px] leading-none cursor-pointer " />
                </div> */}
              </div>
              <div className="text-2xl text-[#151D48] font-semibold pt-4">
                {data?.data?.total_enterprises || 0}
              </div>
              <div className="text-sm text-[#425166] font-medium break-words line-clamp-2">
                Total Enterprises Count
              </div>
            </div>
          </div>
        </div>
        <div className="card-chart bg-white lg:h-full h-auto px-4 py-3 rounded-[20px] shadow-sm flex flex-col">
          <div className="flex justify-between items-end w-full gap-x-3">
            <div className="font-semibold text-lg text-[#05004E]">Total Views</div>
            <div className="flex justify-end items-end gap-x-2">
              <SimpleSelect
                isSearchable={false}
                value={selectedType}
                isFormAppearance
                options={[
                  {
                    label: 'Total Views',
                    value: 'totalViews',
                  },
                  {
                    label: 'Content Creator',
                    value: 'content_creator',
                  },
                  {
                    label: 'Enterprise',
                    value: 'enterprise',
                  },
                ]}
                onChange={(e: any) => {
                  setSelectedType(e);
                }}
              />

              <div className="w-fit">
                <Input
                  value={`${formatDate(selectedDate.startDate)} - ${formatDate(
                    selectedDate.endDate,
                  )}`}
                  icon="ri-calendar-line !text-[#0F3659] !text-sm"
                  onclick={() => {
                    setIsOpenDatePicker(!isOpenDatePicker);
                  }}
                  inputClassName="border border-[#C3D3E2] !text-sm !rounded-lg w-[220px] !h-[37.6px] !text-[#0F3659] cursor-pointer"
                />

                <div
                  className={CN(
                    'fixed h-full bg-black bg-opacity-40 flex justify-center items-center z-50 shadow-lg top-0 bottom-0 right-0 left-0',
                    {
                      hidden: !isOpenDatePicker,
                    },
                  )}
                >
                  <div className="bg-white  border border-neutral-200" ref={pickerRef}>
                    <ComplexDateRangePicker
                      isResponsive
                      isEnableClearButton={false}
                      selectedDate={[selectedDate?.startDate, selectedDate?.endDate]}
                      onChange={(dates: any) => {
                        setSelectedDate({
                          startDate: dates?.startDate,
                          endDate: dates?.endDate,
                        });
                      }}
                      onClose={() => {
                        setIsOpenDatePicker(false);
                        getDashboardActivityInMins();
                      }}
                      showDateDisplay={false}
                      isStaticRanges
                      isRangesDisable
                    />
                  </div>
                </div>
              </div>

              <Button
                appearance="secondary"
                onClick={() => {
                  if (selectedType.value === 'totalViews') {
                    getDashboardExportReport();
                  } else {
                    getDashboardGenerateReportByDateRange();
                  }
                }}
                isLoading={
                  getDashboardExportReportIsLoading ||
                  getDashboardGenerateReportByDateRangeIsLoading
                }
              >
                <i className="ri-upload-2-line pr-2" />
                Export
              </Button>
            </div>
          </div>

          <div className="flex-1 pt-5 h-[200px] w-full">
            <Bar data={chartData} options={chartOptions} />
          </div>
        </div>
      </div>
      <div className="flex flex-col h-auto lg:w-2/5 w-full gap-5">
        <div className="card-summary-2 bg-white h-auto px-4 py-3 rounded-[20px] flex flex-col justify-between shadow-sm">
          <div className="font-semibold text-lg text-[#05004E]">Summary</div>

          <div className="flex justify-between items-center gap-x-3 pt-3">
            <div className="w-1/2 h-[164px] bg-[#FFF4DE] rounded-2xl p-3">
              <div className="flex items-start justify-end w-full">
                <div className="h-10 w-10 rounded-full bg-[#FF947A] flex justify-center items-center">
                  <i className="ri-timer-line text-white text-[22px] leading-none" />
                </div>
                {/* <div className="border border-[#FF947A] rounded px-3 w-fit flex justify-center items-center hover:bg-[#ffdee5]">
                  <i className="ri-arrow-right-long-line text-[#FF947A] text-[16px] leading-none cursor-pointer " />
                </div> */}
              </div>
              <div className="text-xl text-[#151D48] font-semibold pt-0">
                {monthStats?.last_month?.watch_time?.minutes || 0} Mins
                <div className="text-sm text-[#425166] font-medium">{`Last month's watch time`}</div>
              </div>

              <div className="text-xl text-[#151D48] font-semibold pt-2">
                {monthStats?.current_month?.watch_time?.minutes || 0} Mins
                <div className="text-sm text-[#425166] font-medium">{`Current month's watch time`}</div>
              </div>
            </div>

            <div className="w-1/2 h-[164px] bg-[#FFE2E5] rounded-2xl p-3">
              <div className="flex items-start justify-end w-full">
                <div className="h-10 w-10 rounded-full bg-[#FA5A7D] flex justify-center items-center">
                  <i className="ri-money-dollar-box-line text-white text-[22px] leading-none" />
                </div>
                {/* <div className="border border-[#FA5A7D] rounded px-3 w-fit flex justify-center items-center hover:bg-[#f9cfd8]">
                  <i className="ri-arrow-right-long-line text-[#FA5A7D] text-[16px] leading-none cursor-pointer " />
                </div> */}
              </div>
              <div className="text-xl text-[#151D48] font-semibold pt-0">
                {monthStats?.last_month?.ticket_count || 0}
                <div className="text-sm text-[#425166] font-medium">
                  {/* {new Date(new Date().setMonth(new Date().getMonth() - 1)).toLocaleString(
                  'default',
                  { month: 'long' },
                )} */}
                  {`Last month's ticket count`}
                </div>
              </div>

              <div className="text-xl text-[#151D48] font-semibold pt-1">
                {monthStats?.current_month?.ticket_count || 0}
                <div className="text-sm text-[#425166] font-medium">
                  {`Current month's ticket count`}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card-list bg-white p-4 w-full rounded-[20px] lg:h-full h-auto lg:overflow-y-auto overflow-visible shadow-sm">
          <div className="font-semibold text-lg text-[#05004E]">Trending Videos</div>

          <div className="pt-5 flex flex-col w-full">
            <div className="flex justify-between w-full text-[#96A5B8] pb-2 mb-1 border-b border-[#EDF2F6]">
              <div className="w-2/12 text-xs">#</div>
              <div className="w-5/12 text-xs">Title</div>
              <div className="w-2/12 text-xs">Watch time</div>
              <div className="w-3/12 text-xs">Creator</div>
            </div>

            <div className="w-full flex flex-col lg:overflow-y-auto h-full">
              {top10Videos?.map((data: any, index) => (
                <div
                  className="flex justify-between w-full text-[#444A6D] py-3 border-b border-[#EDF2F6]"
                  key={index}
                >
                  <div className="w-2/12 text-xs">
                    {index < 9 && `0`}
                    {index + 1}
                  </div>
                  <div className="w-5/12 text-xs">{data.title || ''}</div>
                  <div className="w-2/12 text-xs">
                    <div className="flex justify-center items-center w-fit px-3 py-[2px] border rounded-lg text-[#C40D42] border-[#C40D42] bg-[#eba5ba] bg-opacity-20">
                      {data?.watch_time_minutes || '--'}
                    </div>
                  </div>
                  <div className="w-3/12 text-xs capitalize">{data?.uploaded_by || ''}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
